import {
  getSessionItem,
  removeSessionItem,
  setSessionItem,
} from "utils/safeStorage";

const RELOAD_FLAG = "mole:stale-build-reloaded";
const RELOAD_WINDOW_MS = 60 * 1000;

/**
 * Deploy sonrası tarayıcıda önbelleklenmiş index.html, artık var olmayan bundle
 * hash'lerini ister. Sunucu (try_files) bu isteklere index.html döndürdüğü için
 * tarayıcı HTML'i JS olarak çalıştırmayı dener ve `React.lazy` import'u patlar.
 * Bu durumda tek çare sayfayı önbelleği atlayarak yeniden yüklemektir.
 */
export const isStaleBuildError = (error) => {
  if (!error) return false;

  if (error.name === "ChunkLoadError") return true;

  const message = `${error.message || ""} ${error.toString?.() || ""}`;

  return [
    "Loading chunk",
    "Loading CSS chunk",
    "ChunkLoadError",
    "Unexpected token '<'",
    "Unexpected token <",
    "expected expression, got '<'",
    "Importing a module script failed",
    "error loading dynamically imported module",
    "Failed to fetch dynamically imported module",
    "'text/html' is not a valid JavaScript MIME type",
  ].some((pattern) => message.includes(pattern));
};

const hasRecentlyReloaded = () => {
  const raw = getSessionItem(RELOAD_FLAG);
  if (!raw) return false;
  const at = Number(raw);
  if (!Number.isFinite(at)) return false;
  return Date.now() - at < RELOAD_WINDOW_MS;
};

/**
 * Bir kez cache-bust'lı reload dener. Sonsuz reload döngüsüne girmemek için
 * sessionStorage'da işaret bırakır.
 * @returns {boolean} reload tetiklendi mi
 */
export const recoverFromStaleBuild = () => {
  if (hasRecentlyReloaded()) {
    return false;
  }

  setSessionItem(RELOAD_FLAG, String(Date.now()));

  try {
    const url = new URL(window.location.href);
    url.searchParams.set("_v", String(Date.now()));
    window.location.replace(url.toString());
  } catch {
    window.location.reload();
  }

  return true;
};

export const clearStaleBuildFlag = () => removeSessionItem(RELOAD_FLAG);

/**
 * Render dışında (ör. `import()` promise'i, script onerror) oluşan bayat build
 * hatalarını da yakalar.
 */
export const registerStaleBuildListeners = () => {
  const handleRejection = (event) => {
    if (isStaleBuildError(event?.reason)) {
      recoverFromStaleBuild();
    }
  };

  const handleError = (event) => {
    if (isStaleBuildError(event?.error)) {
      recoverFromStaleBuild();
    }
  };

  window.addEventListener("unhandledrejection", handleRejection);
  window.addEventListener("error", handleError);

  return () => {
    window.removeEventListener("unhandledrejection", handleRejection);
    window.removeEventListener("error", handleError);
  };
};
